import React, { useEffect } from "react";
import ClassDetailTab from "./ClassDetailTab";
import { useSelector } from "react-redux";

export default function ClassDetailBox({ data }) {
  const background = useSelector((state) => state.classData)
  console.log('background :>> ', background);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div
      style={{ backgroundColor: background?.bgcolor || "#FFE5EC" }}
      className="relative min-h-screen"
    >
      <img
        src={data?.largeLogoUrl}
        alt={data?.className}
        className="absolute right-4 -top-[75px] -z-10 rotate-12 size-28 object-contain object-center"
      />

      <div className="max-w-7xl mx-auto px-5 py-10">
        <ClassDetailTab />
      </div>
    </div>
  );
}
